import { render } from "./AdminEmployees.vue?vue&type=template&id=bf39d01e&scoped=true&ts=true"
import script from "./AdminEmployees.vue?vue&type=script&lang=ts"
export * from "./AdminEmployees.vue?vue&type=script&lang=ts"

import "./AdminEmployees.vue?vue&type=style&index=0&id=bf39d01e&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf39d01e"]])

export default __exports__